import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Highcharts, { charts } from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { HPMNCountry } from 'src/app/tarriff/model/HPMNCountry';
import { HPMNNetwork } from '../model/report/HPMNNetwork';
import { VPMNCountry } from '../model/report/VPMNCountry';
import { VPMNNetwork } from '../model/report/VPMNNetwork';
import { Zone } from '../model/report/Zone';
import { ReportService } from '../service/report.service';
import { SeriesColumnOptions } from 'highcharts';
exporting(Highcharts);


@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss']
})
export class BarComponent implements OnInit {
  summaryForm: FormGroup;
  loadPage: boolean;
  vpmnNetworkList: [];
  vpmnCountryList: [];
  callRoamingPartner: boolean;
  operatorData: any;
  hpmnCountry: any;
  hpmnNetwork: HPMNNetwork[];
  vpmnCountry: VPMNCountry[];
  vpmnNetwork: VPMNNetwork[];
  Zone: Zone[];
  summaryGrowthData: any = [];
  startDate: any;
  endDate: any;
  updateFlag = false;
  summaryOverViewData: [];
  summaryGraphData: any = [];
  public sessionStorage = sessionStorage;
  monthlyReports: any;
  AveragePackSuccess: any;
  AverageCustomerGrowth: any;
  PackActivationDeviance: any;
  AverageMessagingSuccess: any;
  AverageMessagingDeviation: any;

  constructor(private reportService: ReportService, private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService,
    private router: Router, private endpointsService: EndpointsService, private backendApiService: BackendApiService) {
    this.hpmnCountry = (sessionStorage.getItem('homeCountry'));
    this.hpmnNetwork = this.reportService.getHPMNNetwork();
    this.vpmnCountry = this.reportService.getVPMNCountry();
    this.vpmnNetwork = this.reportService.getVPMNNetwork();
    this.Zone = this.reportService.getZone();
  }

  public highChartData: any = [{ name: 'REVENUE GROWTH', data: [0, 11.1, 10.0, -9.1, 10.0, 3.6, 3.5, 3.4, 3.3, 19.0, 27.3, 44.0] },
  { name: 'CUSTOMER GROWTH', data: [0, 8.1, 7.5, 7.0, 6.5, 6.1, 5.8, 5.5, 5.2, 4.9, 4.7, 4.5] },
  { name: 'AOV GROWTH', data: [0, 11.1, -33.3, -10.0, -16.7, -25.3, 141.1, 11.1, -33.3, -10.0, -16.7, -25.3] },
  ]
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Cycle Data by Month'
    },
    xAxis: {
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    },

    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        pointRange: 1.5

      }
    },
    series: this.highChartData,
  };

  ngOnInit() {
    this.createSummaryForm();
    this.getApiOnLoad();
    this.getCountry();
    this.callAPI(null, null);
    this.storeAnalytics();
    this.loadPage = true;
    // this.getUser();
  }

  createSummaryForm() {
    this.summaryForm = this.formBuilder.group({
      hpmnCountry: [''],
      hpmnNetwork: [''],
      vpmnCountry: [''],
      vpmnNetwork: [''],
      Zone: [''],
      startDate: [''],
      endDate: ['']
    });
  }

  get f() {
    return this.summaryForm.controls;
  }

  getOperatorAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.callRoamingPartner = false;
      this.summaryForm.controls.
        roamingPartner.setValue('1', { onlySelf: true });
      this.summaryForm.controls.
        tadIg.setValue('1', { onlySelf: true });
    } else {
      this.getOperatorList(event.target.value).then();
    }
  }

  async getOperatorList(country: string) {
    this.operatorData = [];
    this.operatorData.push({ operator: 'MTN' });
    this.summaryForm.get('hpmnNetwork').setValue('MTN');
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  callAPI(startDate, endDate) {
    let apiUrl = this.endpointsService.URL_GET_SUMMARY_GRAPHS +
      '&hpmnCountry=' + this.summaryForm.get('hpmnCountry').value + '&hpmnNetwork=' + this.summaryForm.get('hpmnNetwork').value +
      '&vpmnCountry=' + this.summaryForm.get('vpmnCountry').value + '&vpmnNetwork=' + this.summaryForm.get('vpmnNetwork').value +
      '&userOrgId=' + sessionStorage.getItem('userOrgId');
    if (startDate && endDate) {
      apiUrl = apiUrl + '&startDate=' + startDate + '&endDate=' + endDate;
    }
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.summaryGraphData = response;
      this.setGraphValues();
    });
  }

  // getUser(){
  //   const apiUrl1 = this.endpointsService.URL_GET_ALL_USERS;
  //   // const apiUrl1 = 'https://rmsdemologin.tevas.in/UserServlet?reportType=getallusers'

  //   this.backendApiService.callToApi(apiUrl1).subscribe(response => {
  //   //   this.roleData = response;
  //   console.log("respose",response);
  //    });
  // }

  onSearch() {
    this.spinnerService.show();
    this.storeAnalytics();
    const startDateFrom = this.summaryForm.get('startDate').value;
    const endDateTo = this.summaryForm.get('endDate').value;
    if (startDateFrom && endDateTo) {
      const dateFrom = new Date();
      dateFrom.setDate(startDateFrom.day);
      dateFrom.setMonth(startDateFrom.month - 1);
      dateFrom.setFullYear(startDateFrom.year);
      const dateTo = new Date();
      dateTo.setDate(endDateTo.day);
      dateTo.setMonth(endDateTo.month - 1);
      dateTo.setFullYear(endDateTo.year);
      if (dateTo.getTime() < dateFrom.getTime()) {
        alert('End date can\'t be less than Start date');
        return;
      }
      this.startDate = formatDate(dateFrom, 'yyyy-MM-dd', 'en');
      this.endDate = formatDate(dateTo, 'yyyy-MM-dd', 'en');
    }
    this.callAPI(this.startDate, this.endDate);
  }

  setGraphValues() {
    if (this.summaryGraphData) {
      var chart = Highcharts.chart({
        chart: {
          renderTo: 'getSmsSummary',
          type: 'column'
        },
        title: {
          text: 'SMS Summary'
        },
        xAxis: {
          categories: this.summaryGraphData['getSmsSummary'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Volume/Nos.'
          }
        },
        legend: {
          reversed: false
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getSmsSummary)) ? this.summaryGraphData['getSmsSummary'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });


      if (!this.isEmpty(this.summaryGraphData)) {
  const counts = this.summaryGraphData.getDailySmsPdpHistoryCounts;
  const categories = Object.keys(counts); // ['blocked','unblocked']

  // Tell TS this is specifically an array of column-series options
  const series: SeriesColumnOptions[] = categories.map(key => ({
    name: key,
    type: 'column',
    data: [ counts[key] ]
  }));

 Highcharts.chart(
  'getDailySmsPdpHistoryCounts',
  {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Daily SMS PDP History Counts'
    },
    xAxis: {
      categories: ['Status'] // Single category for all bars
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Count'
      }
    },
    legend: {
      reversed: false
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        // Remove stacking to show bars side-by-side
        // stacking: 'normal'
      }
    },
    series: [
      {
        name: 'Blocked',
        type: 'column',
        data: [16521]
      },
      {
        name: 'Unblocked',
        type: 'column',
        data: [3299]
      }
    ]
  }

  , chart => {
    // on complete: if all zero or no data, show “No Data Available”
   const hasData = series.some(s => 
        s.data.some(v => typeof v === 'number' && v > 0)
      );
    if (!hasData) {
      const texto = chart.renderer
        .text('No Data Available', chart.plotLeft + chart.plotWidth/2, chart.plotTop + chart.plotHeight/2)
        .css({ fontSize: '16px' })
        .attr({ align: 'center' })
        .add();
    }
  });
}
      // if (!this.isEmpty(this.summaryGraphData)) {
      // Highcharts.chart({
      //   chart: {
      //     renderTo: 'getDailySmsPdpHistoryCounts',
      //     type: 'column'
      //   },
      //   title: {
      //     text: 'Roamers Pack History'
      //   },
      //   xAxis: {
      //     categories: this.summaryGraphData['getDailySmsPdpHistoryCounts'].xAxis
      //   },
      //   yAxis: {
      //     min: 0,
      //     title: {
      //       text: 'No. of Roamers'
      //     }
      //   },
      //   legend: {
      //     reversed: true
      //   },
      //   credits: {
      //     enabled: false
      //   },
      //   plotOptions: {
      //     series: {
      //       stacking: 'normal'
      //     }
      //   },
      //   series: (!this.isEmpty(this.summaryGraphData.RoamersPackHistoryInfo)) ? this.summaryGraphData['getDailySmsPdpHistoryCounts'] : []
      // }, function (chart) { // on complete
      //   if (chart.series.length < 1) {
      //     var texto = chart.renderer.text('No Data Available ', 140, 120)
      //       .css({
      //         color: '#4572A7',
      //         fontSize: '16px'
      //       })
      //       .add();
      //     var textBBox = texto.getBBox();
      //     var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
      //     var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
      //     texto.attr({ x: x, y: y, id: 'xtratext' });
      //   }
      // });
      // }

      // if (!this.isEmpty(this.summaryGraphData.Pack_Activation_Summary)) {
      // Highcharts.chart({
      //   chart: {
      //     renderTo: 'getSubscriberCount',
      //     type: 'column'
      //   },
      //   title: {
      //     text: 'Subscriber Count'
      //   },
      //   xAxis: {
      //     categories: this.summaryGraphData['getSubscriberCount'].xAxis
      //   },
      //   yAxis: {
      //     min: 0,
      //     title: {
      //       text: 'No. of Roamers'
      //     }
      //   },
      //   legend: {
      //     reversed: true
      //   },
      //   credits: {
      //     enabled: false
      //   },
      //   plotOptions: {
      //     series: {
      //       stacking: 'normal'
      //     }
      //   },
      //   series: (!this.isEmpty(this.summaryGraphData.getSubscriberCount)) ? this.summaryGraphData['getSubscriberCount'].graphSeries : []
      // }, function (chart) { // on complete
      //   if (chart.series.length < 1) {
      //     var texto = chart.renderer.text('No Data Available ', 140, 120)
      //       .css({
      //         color: '#4572A7',
      //         fontSize: '16px'
      //       })
      //       .add();
      //     var textBBox = texto.getBBox();
      //     var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
      //     var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
      //     texto.attr({ x: x, y: y, id: 'xtratext' });
      //   }
      // });


      Highcharts.chart({
        chart: {
          renderTo: 'getPackActivationSummary',
          type: 'column'
        },
        title: {
          text: 'Pack Activation Summary'
        },
        xAxis: {
          categories: this.summaryGraphData['getPackActivationSummary'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Volume of Activation'
          }
        },
        legend: {
          reversed: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getPackActivationSummary)) ? this.summaryGraphData['getPackActivationSummary'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });



      // Highcharts.chart({
      //   chart: {
      //     renderTo: 'MessageCount',
      //     type: 'column'
      //   },
      //   title: {
      //     text: 'In Subscriber Count'
      //   },
      //   xAxis: {
      //     categories: this.summaryGraphData['MessageCount'].xAxis
      //   },
      //   yAxis: {
      //     min: 0,
      //     title: {
      //       text: 'No. of Roamers'
      //     }
      //   },
      //   legend: {
      //     reversed: true
      //   },
      //   credits: {
      //     enabled: false
      //   },
      //   plotOptions: {
      //     series: {
      //       stacking: 'normal'
      //     }
      //   },
      //   series: (!this.isEmpty(this.summaryGraphData.MessageCount)) ? this.summaryGraphData['MessageCount'].graphSeries : []
      // }, function (chart) { // on complete
      //   if (chart.series.length < 1) {
      //     var texto = chart.renderer.text('No Data Available ', 140, 120)
      //       .css({
      //         color: '#4572A7',
      //         fontSize: '16px'
      //       })
      //       .add();
      //     var textBBox = texto.getBBox();
      //     var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
      //     var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
      //     texto.attr({ x: x, y: y, id: 'xtratext' });
      //   }
      // });
      // Highcharts.chart({
      //   chart: {
      //     renderTo: 'inSubscriberCount',
      //     type: 'column'
      //   },
      //   title: {
      //     text: 'In Subscriber Count'
      //   },
      //   xAxis: {
      //     categories: this.summaryGraphData['inSubscriberCount'].xAxis
      //   },
      //   yAxis: {
      //     min: 0,
      //     title: {
      //       text: 'No. of Roamers'
      //     }
      //   },
      //   legend: {
      //     reversed: true
      //   },
      //   credits: {
      //     enabled: false
      //   },
      //   plotOptions: {
      //     series: {
      //       stacking: 'normal'
      //     }
      //   },
      //   series: (!this.isEmpty(this.summaryGraphData.inSubscriberCount)) ? this.summaryGraphData['inSubscriberCount'].graphSeries : []
      // }, function (chart) { // on complete
      //   if (chart.series.length < 1) {
      //     var texto = chart.renderer.text('No Data Available ', 140, 120)
      //       .css({
      //         color: '#4572A7',
      //         fontSize: '16px'
      //       })
      //       .add();
      //     var textBBox = texto.getBBox();
      //     var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
      //     var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
      //     texto.attr({ x: x, y: y, id: 'xtratext' });
      //   }
      // });


      Highcharts.chart({
        chart: {
          renderTo: 'getErrorAct',
          type: 'column'
        },
        title: {
          text: 'Pack/Offer Activation Statistics'
        },
        xAxis: {
          categories: this.summaryGraphData['getErrorAct'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Volume/Nos.'
          }
        },
        legend: {
          reversed: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getErrorAct)) ? this.summaryGraphData['getErrorAct'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });


      Highcharts.chart({
        chart: {
          renderTo: 'getInFailure',
          type: 'column'
        },
        title: {
          text: 'Message Failure'
        },
        xAxis: {
          categories: this.summaryGraphData['getInFailure'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Volume/Nos.'
          }
        },
        legend: {
          reversed: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getInFailure)) ? this.summaryGraphData['getInFailure'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });
      Highcharts.chart({
        chart: {
          renderTo: 'getTop10NetworkNoOfRoamers',
          type: 'column'
        },
        title: {
          text: 'Top 10 Networks (No. of Roamers)'
        },
        xAxis: {
          categories: this.summaryGraphData['getTop10NetworkNoOfRoamers'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Volume of Activation'
          }
        },
        legend: {
          reversed: false
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getTop10NetworkNoOfRoamers)) ? this.summaryGraphData['getTop10NetworkNoOfRoamers'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });

      Highcharts.chart({
        chart: {
          renderTo: 'getTop10Networks',
          type: 'column'
        },
        title: {
          text: 'Top 10 Networks'
        },
        xAxis: {
          categories: this.summaryGraphData['getTop10Networks'].xAxis
        },
        yAxis: {
          min: 0,
          title: {
            text: 'No. of Roamers'
          }
        },
        legend: {
          reversed: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: (!this.isEmpty(this.summaryGraphData.getTop10Networks)) ? this.summaryGraphData['getTop10Networks'].graphSeries : []
      }, function (chart) { // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer.text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px'
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + (chart.plotWidth * 0.5) - (textBBox.width * 0.5);
          var y = chart.plotTop + (chart.plotHeight * 0.5) - (textBBox.height * 0.5);
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      });

      this.updateFlag = true;
    }
  }

  async getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_SUMMARY_GROWTH + '&userOrgId=' + sessionStorage.getItem('userOrgId');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.summaryGrowthData = response;
      this.AveragePackSuccess =this.summaryGrowthData.AveragePackSuccess;
      this.AverageCustomerGrowth =this.summaryGrowthData.AverageCustomerGrowth;
      this.PackActivationDeviance =this.summaryGrowthData.PackActivationDeviance;
      this.AverageMessagingSuccess = this.summaryGrowthData.AverageMessagingSuccess;
      this.AverageMessagingDeviation = this.summaryGrowthData.AverageMessagingDeviation;
      

      this.monthlyReports = this.summaryGrowthData['monthlyReports'];
    });
    console.log(this.AveragePackSuccess);
    // this.getApiOnLoad1();
  }

  getCountry() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      this.summaryForm.controls.vpmnNetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkList = response;
      if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
        this.summaryForm.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      }

    });
  }

  async getApiOnLoad1() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_SUMMARY_OVERVIEW + '&userOrgId=' + sessionStorage.getItem('userOrgId');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.summaryOverViewData = response;
    });
  }

  onReset() {
    // this.spinnerService.show();
    // this.createSummaryForm();
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    this.storeAnalytics1();
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
   storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=summary' + '&module=summary' + '&operation=search';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
    });

  }
 storeAnalytics1() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=summary' + '&module=summary' + '&operation=reset';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
    });

  }

}


